export class CompanyImagesSearchCriteria {
    CompanyId: Number;
    AccountSetupId: Number;
}

export class CompanyImageAccountsSearchCriteria {
    Id: Number;
    CompanyImagesId: Number;
}